import React, { useState } from 'react'
import { Button, DialogTitle, Dialog, DialogContent } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import {
  type DisbursementFeeDetail,
  type DisbursementFeeSummary
} from '../../../../api/schema-dtos/AssetHolderDisbursementDomainDtos'
import { DisbursementSchedule } from '../../../../api/disbursements/DisbursementSchedule'

interface DisbursementFeesComponentProps {
  disbursementFees: DisbursementFeeSummary[]
}

const DisbursementFeesComponent: React.FC<DisbursementFeesComponentProps> = ({ disbursementFees }: DisbursementFeesComponentProps) => {
  const [openDialog, toggleDialog] = useState<boolean>(false)

  const getBtcDisbursementFees = (fees: DisbursementFeeSummary[]): DisbursementFeeSummary[] => {
    return fees.filter(fee => fee.currency === 'Bitcoin')
  }

  const getZarDisbursementFees = (fees: DisbursementFeeSummary[]): DisbursementFeeSummary[] => {
    return fees.filter(fee => fee.currency === 'South African Rand')
  }

  const getFees = (fees: DisbursementFeeSummary[]): DisbursementFeeDetail[] => {
    return [
      {
        schedule: 'Every Wednesday',
        bankAccount: `ZAR ${getZarDisbursementFees(fees).find(fee => fee.payoutSchedule === DisbursementSchedule.WEEKLY)?.amount ?? 0}`,
        btcWallet: `BTC ${getBtcDisbursementFees(fees).find(fee => fee.payoutSchedule === DisbursementSchedule.WEEKLY)?.amount ?? 0}`
      }
      // {
      //   schedule: 'Next Business Day',
      //   bankAccount: `ZAR ${getZarDisbursementFees(fees).find(fee => fee.payoutSchedule === DisbursementSchedule.IMMEDIATE)?.amount ?? 0}`,
      //   btcWallet: `BTC ${getBtcDisbursementFees(fees).find(fee => fee.payoutSchedule === DisbursementSchedule.IMMEDIATE)?.amount ?? 0}`
      // }
    ]
  }

  return (
    <>
      <Button
        variant={'outlined'}
        color={'primary'}
        sx={{ mt: 2, mr: 2 }}
        onClick={() => { toggleDialog(true) }}
      >
        Show Fees
      </Button>

      <Dialog
        open={openDialog}
        maxWidth={'sm'}
        fullWidth={true}
        disableEscapeKeyDown={true}
        onClose={() => { toggleDialog(false) }}
        sx={{ p: 2 }}
      >
        <DialogTitle>Cash Out Fees</DialogTitle>
        <DialogContent>
          <TableContainer>
            <Table sx={{}} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Schedule</TableCell>
                  <TableCell align="right">ZAR Bank Account</TableCell>
                  <TableCell align="right">Bitcoin Wallet</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFees(disbursementFees).map((fee: any, index: number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {fee.schedule}
                    </TableCell>
                    <TableCell align="right">{fee.bankAccount}</TableCell>
                    <TableCell align="right">{fee.btcWallet}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button
            variant={'outlined'}
            color={'primary'}
            sx={{ mt: 2 }}
            onClick={() => { toggleDialog(false) }}
          >
            Close
          </Button>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default DisbursementFeesComponent
